(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.filters button').forEach((button)=>button.addEventListener('click',()=>{
    const category=button.dataset.filter;
    document.querySelectorAll('.filters button').forEach((item)=>item.classList.remove('active'));
    button.classList.add('active');
    document.querySelectorAll('.collection-row').forEach((row)=>{
      const cards=[...row.querySelectorAll('.product-card')];
      cards.forEach((card)=>card.hidden=category!=='all'&&card.dataset.cat!==category);
      const lead=row.querySelector('.collection-lifestyle');
      const showLead=category==='all'||lead.dataset.cat===category;
      lead.hidden=!showLead&&cards.every((card)=>card.hidden);
      row.hidden=!showLead&&cards.every((card)=>card.hidden);
    });
  }));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-product"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const details={
      S:{neck:'7.1–9.8 in',width:'1.1 in',weight:'2.2–7.7 lb'},
      M:{neck:'11.0–13.8 in',width:'1.1 in',weight:'6.6–14.3 lb'},
      L:{neck:'15.0–17.7 in',width:'1.1 in',weight:'13.2–22.0 lb'},
      XL:{neck:'18.9–21.7 in',width:'1.1 in',weight:'20.9–44.1 lb'}
    };
    const buttons=[...document.querySelectorAll('.size-picker button')];
    const price=document.querySelector('#productPrice');
    const variantInput=document.querySelector('#MaisonVariantId');
    const fit=document.querySelector('#fitSummary');
    const status=document.querySelector('#purchaseStatus');
    let selected=buttons.find((button)=>button.classList.contains('selected'))||buttons[0];

    function select(button){
      selected=button;
      buttons.forEach((item)=>item.classList.toggle('selected',item===button));
      variantInput.value=button.dataset.variantId;
      price.textContent=button.dataset.price;
      const size=button.dataset.size;
      const fitDetails=details[size]||details.S;
      fit.innerHTML=`<div><span>Neck</span><strong>${fitDetails.neck}</strong></div><div><span>Suggested weight</span><strong>${fitDetails.weight}</strong></div><div><span>Width</span><strong>${fitDetails.width}</strong></div><p>Size ${size} selected. Measure the neck for the most comfortable fit.</p>`;
      status.textContent='';
    }

    async function addToCart(goToCheckout){
      status.textContent='Adding…';
      const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(selected.dataset.variantId),quantity:1}]})});
      if(!response.ok){status.textContent='This selection could not be added. Please try again.';return;}
      if(goToCheckout){window.location.href='/checkout';return;}
      const cart=await fetch('/cart.js').then((result)=>result.json());
      const bag=document.querySelector('#bagCount');
      if(bag) bag.textContent=cart.item_count;
      status.textContent=`Size ${selected.dataset.size} added to bag.`;
    }

    buttons.forEach((button)=>button.addEventListener('click',()=>select(button)));
    document.querySelector('.add-button')?.addEventListener('click',()=>addToCart(false));
    document.querySelector('.buy-now-button')?.addEventListener('click',()=>addToCart(true));
    if(selected) select(selected);
  })();

  } catch(e) { console.error(e); }
})();
})();
